/* src/app/modules/file/files-dialog-move.component.css */
.fm-dir-item {
  cursor: pointer;
  transition: background 0.12s;
}
.fm-dir-item:hover {
  background: var(--cf-bg, #f4f6f8);
}
.fm-dir-item__icon {
  color: var(--cf-brand, #e3fd64) !important;
  font-size: 20px !important;
  width: 20px !important;
  height: 20px !important;
}
.fm-dir-item__name {
  font-size: 13.5px;
  color: var(--cf-text, #1a1d23);
}
.fm-dir-item__arrow {
  color: var(--cf-border-strong, #d1d5db);
  margin-left: auto;
}
.breadcrumb-nav {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 8px 0 16px;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 8px;
}
.breadcrumb-item {
  display: flex;
  align-items: center;
}
.breadcrumb-link {
  color: #3b5bdb;
  cursor: pointer;
  font-size: 13px;
}
.breadcrumb-link:hover {
  text-decoration: underline;
}
.breadcrumb-current {
  font-size: 13px;
  font-weight: 600;
  color: #212529;
}
.breadcrumb-sep {
  font-size: 16px !important;
  color: #adb5bd;
  margin: 0 2px;
}
.loading-container {
  display: flex;
  justify-content: center;
  padding: 32px;
}
.dir-item {
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.15s;
}
.dir-item:hover {
  background: #f1f3f9;
}
.dir-arrow {
  color: #adb5bd;
  margin-left: auto;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  color: #adb5bd;
}
.empty-state mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
}
.empty-state p {
  margin-top: 8px;
  font-size: 14px;
}
/*# sourceMappingURL=files-dialog-move.component.css.map */
